import { useTheme } from '@mui/material/styles';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            marginTop: theme.spacing(1),
            flexWrap: 'wrap',
            gap: theme.spacing(1),
            '& > h1': {
                marginTop: 0,
                flexGrow: 1,
            },
            [theme.breakpoints.down('sm')]: {
                '& *:last-child': {
                    flexGrow: 1,
                },
            },
        },
        regular: {
            width: '70%',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        fullwidth: {
            width: '100%',
        },
    };
};
